import { SurveyType } from "./surveyType.enum";

export class Survey {
    public id: number;
    public name: string;
    public type: string;
}